import { render, staticRenderFns } from "./OurFormationsComp.vue?vue&type=template&id=46bc6476&scoped=true"
import script from "./OurFormationsComp.vue?vue&type=script&lang=js"
export * from "./OurFormationsComp.vue?vue&type=script&lang=js"
import style0 from "./OurFormationsComp.vue?vue&type=style&index=0&id=46bc6476&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46bc6476",
  null
  
)

/* custom blocks */
import block0 from "./OurFormationsComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports